export const setUp = 'setUp'
export const answer = 'answer'
export const countUpHintView = 'countUpHintView'
